import Vue from 'vue'
import store from '@/store/index'
import VueRouter from 'vue-router'
import AuthRoutes from './auth'
import CPanelRoutes from './cpanel'

import { Guest, middlewarePipeline } from './middleware'
Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    redirect: { name: 'auth.signin' },
    component: () => import('@/layouts/auth'),
    children: AuthRoutes,
    meta: {
      middleware: [Guest]
    }
  },
  {
    path: '/',
    name: 'cpanel',
    redirect: { name: 'cpanel.dashboard' },
    component: () => import('@/layouts/default'),
    meta: {
      middleware: [Guest]
    },
    children: CPanelRoutes
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/NotFound'),
    meta: {
      title: 'notFound.title'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

middlewarePipeline(router, store)
export default router
